export default {
  deliveries: [],
  delivery: undefined,
};
